import { Component, useContext } from 'react';
import { DateFilterWidget, getFromDateFromFilter, getToDateFromFilter } from './dateFilter';
import { AppContext } from '@context/app-context';
import { Box, Card, CircularProgress, Stack, } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { getSalesPosting } from '@src/api/reportHandlers';
import EnhancedTable from '@components/enhancedDataGrid';

export default function AccountingGroupReport() {
  const { storeId, allStoresDetails } = useContext(AppContext);
  const storeDetails = allStoresDetails.find(x => x.storeId === storeId) ?? {
    storeId,
    storeName: storeId,
    locale: 'en_US',
    timeZone: 'Asia/Muscat'
  }
  const [searchParams] = useSearchParams();
  const filterParams = Object.fromEntries([...searchParams]);
  return (
    <AccountingGroupReportView
      storeId={storeId}
      storeDetails={storeDetails}
      currentFromDate={filterParams.currentFromDate}
      currentToDate={filterParams.currentToDate}
    />
  );
}
class AccountingGroupReportView extends Component {
  constructor(props) {
    super(props);
    const { storeId, storeDetails } = this.props;
    this.loadReports = this.loadReports.bind(this);
    this.state = {
      storeId,
      reportData: {},
      status: 'LOADING',
      storeDetails
    };
  }

  componentDidMount() {
    const { currentFromDate, currentToDate } = this.props;
    if (currentFromDate == null || currentToDate == null) {
      this.loadReports(getFromDateFromFilter('TODAY'), getToDateFromFilter('TODAY'));
    } else {
      this.loadReports(currentFromDate, currentToDate,
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.storeId !== prevProps.storeId) {
      this.componentDidMount();
    }
  }

  loadReports(fromDate, toDate) {
    const { storeId } = this.props;
    console.log('Loading reports');
    this.setState({
      reportData: null,
      status: 'LOADING',
    });
    getSalesPosting(fromDate, toDate, storeId).then((data) => {
      this.setState({
        reportData: data,
        storeId,
        status: 'LOADED',
      });
    }).catch((err) => {
      console.log('Error while fetching SalesPosting', err.message);
      this.setState({
        reportData: null,
        storeId,
        status: 'ERROR',
      });
    });
  }


  render() {
    const { reportData, status } = this.state;
    const { storeId, storeDetails } = this.props;
    const { currentFromDate, currentToDate } = this.props;
    let dataTemp = reportData?.salesAgg?.salesGroups ?? [];
    let data = [];

    let i = 0;
    dataTemp.forEach(datapoint => {
      data.push({ ...datapoint, id: i, name: datapoint.method });
      i++;
    });

    const headCells = [
      { id: 'group', numeric: true, disablePadding: true, label: 'Accounting Group', },
      { id: 'quantity', numeric: true, disablePadding: false, label: 'Quantity', },
      { id: 'total', numeric: true, disablePadding: false, label: 'Total', },
      { id: 'discount', numeric: true, disablePadding: false, label: 'Discounts', },
      { id: 'totalWTaxWDiscount', numeric: true, disablePadding: false, label: 'Total with Tax less Discounts', },
      { id: 'amountTaxed', numeric: true, disablePadding: false, label: 'Taxable Amt', },
      { id: 'vat5', numeric: true, disablePadding: false, label: 'VAT 5%', },
      { id: 'tax', numeric: true, disablePadding: false, label: 'Total Tax', },
      { id: 'percent', numeric: true, disablePadding: false, label: 'Percent', },
      { id: 'totalWOTaxWDiscount', numeric: true, disablePadding: false, label: 'Total w/o Tax', },
    ];


    return (
      <Box
        sx={{
          backgroundColor: '#e2e2e2',
          width: '100%',
          height: '100%',
          overflow: 'auto',
        }}
      >
        <Stack direction="column" sx={{ height: '100%', paddingX: 1, paddingY: 0 }} spacing={1}>
          <Box>
            <Card>
              <DateFilterWidget
                fetchReports={this.loadReports}
                fromDate={currentFromDate}
                toDate={currentToDate}
                storeDetails={storeDetails}
              />
            </Card>
          </Box>
          {status === 'LOADING' ?
            (<Stack direction="row" sx={{ height: '100%', width: '100%', paddingX: 2, paddingY: 1 }} spacing={2} justifyContent="center">
              <CircularProgress />
            </Stack>)
            : status === 'ERROR' ?
              (<Stack direction="row" justifyContent="center">Opps! We encountered an issue while fetching the report data!!</Stack >)
              : data ?
                <Box style={{
                  boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
                  borderRadius: '4px',
                  backgroundColor: 'white'
                }}>
                  <EnhancedTable
                    headCells={headCells}
                    rows={data}
                    title={'SALES POSTING - Accounting Groups'}
                    downloadFileName={`${storeDetails.storeName}_${storeId}_SALES_POSTING_AccountingGroups.csv`} />
                </Box>
                :
                <>No Data</>}
        </Stack>
      </Box>
    )
  }
}
